;(function () {
	const getMedia = (deferredMedia) =>
		deferredMedia?.querySelector('video, iframe')

	const playMedia = (media) => {
		if (!media) return

		if (media.nodeName === 'VIDEO') {
			media.play().catch(() => {})
			return
		}

		if (media.classList.contains('js-youtube')) {
			media.contentWindow.postMessage(
				'{"event":"command","func":"playVideo","args":""}',
				'*'
			)
			return
		}

		if (media.classList.contains('js-vimeo')) {
			media.contentWindow.postMessage('{"method":"play"}', '*')
		}
	}

	const pauseMedia = (media) => {
		if (!media) return

		if (media.nodeName === 'VIDEO') {
			media.pause()
			return
		}

		if (media.classList.contains('js-youtube')) {
			media.contentWindow.postMessage(
				'{"event":"command","func":"pauseVideo","args":""}',
				'*'
			)
			return
		}

		if (media.classList.contains('js-vimeo')) {
			media.contentWindow.postMessage('{"method":"pause"}', '*')
		}
	}

	const applyMutedState = (media, muted) => {
		if (!media) return

		if (media.nodeName === 'VIDEO') {
			media.muted = muted
			return
		}

		if (media.classList.contains('js-youtube')) {
			media.contentWindow.postMessage(
				JSON.stringify({
					event: 'command',
					func: muted ? 'mute' : 'unMute',
					args: '',
				}),
				'*'
			)
			media.classList.toggle('video-muted', muted)
			return
		}

		if (media.classList.contains('js-vimeo')) {
			media.contentWindow.postMessage(
				JSON.stringify({ method: 'setVolume', value: muted ? 0 : 1 }),
				'*'
			)
			media.classList.toggle('video-muted', muted)
		}
	}

	const bindVideoEnded = (deferredMedia, onEnded) => {
		const media = getMedia(deferredMedia)
		if (!media || media.nodeName !== 'VIDEO' || media.dataset.fwvbEndedBound) return

		media.dataset.fwvbEndedBound = 'true'
		media.addEventListener('ended', onEnded)
	}

	const bindMediaPlaybackSync = (banner, playBtn, deferredMedia) => {
		const media = getMedia(deferredMedia)
		if (!media || media.nodeName !== 'VIDEO' || media.dataset.fwvbPlaybackBound) return

		media.dataset.fwvbPlaybackBound = 'true'
		media.addEventListener('play', () => {
			if (playBtn) playBtn.classList.add('active')
			banner.classList.add('is-playing')
		})
		media.addEventListener('pause', () => {
			if (playBtn) playBtn.classList.remove('active')
			banner.classList.remove('is-playing')
		})
	}

	const initBanner = (banner) => {
		if (banner.dataset.fwvbInit) return
		banner.dataset.fwvbInit = 'true'

		const playBtn = banner.querySelector('[data-fw-video-banner-play]')
		const muteBtn = banner.querySelector('[data-fw-video-banner-mute]')
		const deferredMedia = banner.querySelector('deferred-media')
		if (!deferredMedia) return

		const poster = deferredMedia.querySelector('[id^="Deferred-Poster-"]')
		let isMuted = banner.dataset.startMuted === 'true'

		const setMuted = (muted) => {
			isMuted = muted
			applyMutedState(getMedia(deferredMedia), muted)
		}

		const setPlaying = (playing) => {
			if (playBtn) playBtn.classList.toggle('active', playing)
			banner.classList.toggle('is-playing', playing)
		}

		const syncMediaState = () => {
			const media = getMedia(deferredMedia)
			if (!media) return

			applyMutedState(media, isMuted)

			if (media.nodeName === 'VIDEO') {
				setPlaying(!media.paused)
			}
		}

		const play = () => {
			if (!deferredMedia.hasAttribute('loaded')) {
				poster?.click()
				setPlaying(true)
				return
			}

			setPlaying(true)
			playMedia(getMedia(deferredMedia))
		}

		const pause = () => {
			setPlaying(false)
			pauseMedia(getMedia(deferredMedia))
		}

		if (playBtn) {
			playBtn.addEventListener('click', () => {
				playBtn.classList.contains('active') ? pause() : play()
			})
		}

		if (muteBtn) {
			muteBtn.addEventListener('click', () => {
				setMuted(!isMuted)
				muteBtn.classList.toggle('active')
			})
		}

		const observer = new MutationObserver(() => {
			bindVideoEnded(deferredMedia, pause)
			bindMediaPlaybackSync(banner, playBtn, deferredMedia)
			syncMediaState()
		})
		observer.observe(deferredMedia, { childList: true })
		bindVideoEnded(deferredMedia, pause)
		bindMediaPlaybackSync(banner, playBtn, deferredMedia)
		syncMediaState()

		if (banner.dataset.videoAutoplay === 'true' && playBtn) {
			setPlaying(true)
		}
	}

	const initAll = () => {
		document.querySelectorAll('[data-fw-video-banner]').forEach(initBanner)
	}

	initAll()

	document.addEventListener('shopify:section:load', (event) => {
		const banner = event.target?.querySelector('[data-fw-video-banner]')
		if (banner) {
			delete banner.dataset.fwvbInit
			initBanner(banner)
		} else {
			initAll()
		}
	})
})()
